import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import {DispatchAny} from '@pluto/@types';
import {setNotificationAction} from '@pluto/notification';
import {deliveryContentItem,getContentItemViewTitles} from '@pluto/rest';
import {QcJobStatusIndicatorStateItem} from '../JobStatusIndicator/JobStatusIndicatorTypes';
import {getDeliveryJobsStatusAction} from '../../QCTools/Redux/QCToolsActions';

export const CONTENT_ITEM_VIEW_STATE_SET = 'CONTENT_ITEM_VIEW_STATE_SET';
export const GET_DELIVERY_JOBS_STATUS = 'GET_DELIVERY_JOBS_STATUS';
export const GET_CONTENT_ITEM_VIEW_TITLES = 'GET_CONTENT_ITEM_VIEW_TITLES';
export const RESET_JOB_DELIVERY_STATUS = 'RESET_JOB_DELIVERY_STATUS';
export const RESET_QC_JOB_STATE = 'RESET_QC_JOB_STATE';

export type QcJobStatusIndicatorPayload = QcJobStatusIndicatorStateItem[];

export const resetQcJobStateAction = createAction(RESET_QC_JOB_STATE);

export const setContentItemViewTitles = createAction(
    GET_CONTENT_ITEM_VIEW_TITLES,
    async (id: string) => {
        const response = (await getContentItemViewTitles(id)) as any;

        return response;
    }
);

export const deliveryContentItemAction = curry(async (qcJobId: number, dispatch: DispatchAny) => {
    try {
        const response = await deliveryContentItem(qcJobId);

        if (response.statusText === 'OK') {
            dispatch(getDeliveryJobsStatusAction(qcJobId));
        }
    } catch {
        dispatch(setNotificationAction({
            type: 'error',
            text: 'Error occured while delivering job',
        }));
    }
});

export const resetJobDeliveryStatusAction = createAction(RESET_JOB_DELIVERY_STATUS);
